import React from "react"
import {
  Main,
  AgentImageBox,
  Name,
  AgentDataBox,
  Email,
  Phone,
  UASpan,
} from "./style"
import uaFlag from "../../../../images/ua-flag.jpg"

const SingleAgent = ({
  image,
  name,
  phone,
  email,
  toggleOpen,
  ua,
  fn,
  goldBackground = true,
}) => {
  return (
    <Main onClick={() => fn(email)}>
      <AgentImageBox
        onClick={() => toggleOpen(true)}
        style={{
          background: goldBackground
            ? "linear-gradient(180deg, #eae69c 0%, #b6872d 100%)"
            : "transparent",
        }}
      >
        <img src={image} alt="zdjęcie" />
      </AgentImageBox>
      <AgentDataBox>
        <Name>{name}</Name>
        <Phone>
          <a href={`tel:${phone}`}>{phone}</a>
        </Phone>
        <Email>{email}</Email>
        {ua && (
          <UASpan>
            <img src={uaFlag} alt="flag" />
            <p>Говорю на українській мові</p>
          </UASpan>
        )}
      </AgentDataBox>
    </Main>
  )
}

export default SingleAgent
